export function BootScreen() {
  return (
    <div className="qs-boot" aria-hidden="true">
      <div className="qs-boot-name">QronStat</div>
      <div className="qs-boot-row">
        <div className="qs-boot-card" />
        <div className="qs-boot-card" />
        <div className="qs-boot-card" />
        <div className="qs-boot-card" />
      </div>
      <div className="qs-boot-wide" />
    </div>
  );
}
